module.exports = __webpack_public_path__ + "static/img/1-role.63a50ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/1-role.png
// module id = M/aa
// module chunks = 1